<template>
  <div
    v-if="group">
    <v-flex
      xs12
      md12>
      <material-card
        v-bind="{ title: getTitle(), text: getText() }"
        color="dover-blue"
        icon="mdi-account-convert">
        <v-layout
          wrap>
          <v-flex
            xs12
            md12
            lg12
            text-xs-center>
            <span
              class="dover-blue-color">
              {{ $t('Last measure: {0}', [currentDate]).toUpperCase() }}
            </span>
            <hr>
          </v-flex>
          <v-flex
            xs12
            md12
            lg12
            text-xs-center>
            <img
              :src="imageUrl"
              width="40%" >
          </v-flex>
          <v-flex
            xs12
            md4
            lg4>
            <material-stats-card
              v-bind="{ title: `${ $t(volumeUnit) }`, value: Maglink.VolumeToDisplay(group.lastMeasurement.productVolume, systemSettings.volumeUnit) }"
              :sub-text="`${ $t('Volume') }`"
              color="dover-blue"
              icon="mdi-chart-gantt"/>
          </v-flex>
          <v-flex
            xs12
            md4
            lg4>
            <material-stats-card
              v-bind="{ title: `${ $t(volumeUnit) }`, value: Maglink.VolumeToDisplay(group.lastMeasurement.waterVolume, systemSettings.volumeUnit) }"
              :sub-text="`${ $t('Water volume') }`"
              color="dover-blue"
              icon="mdi-water"/>
          </v-flex>
          <v-flex
            xs12
            md4
            lg4>
            <material-stats-card
              v-bind="{ value: Maglink.RoundFormat(group.lastMeasurement.weight, 2) }"
              :title="`${ $t('Kg') }`"
              :sub-text="`${ $t('Weight') }`"
              color="dover-blue"
              icon="mdi-weight-kilogram"/>
          </v-flex>
        </v-layout>
      </material-card>
    </v-flex>
  </div>
</template>

<script>

export default {
  props: {
    group: {
      type: Object,
      required: true,
      default: () => {}
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => {}
    },
    options: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    tankGroupInfo: '',
    tankList: []
  }),
  computed: {
    densityValues () {
      return this.Maglink.DensityFormat(this.group.lastMeasurement.density) + ' (' + this.Maglink.DensityFormat(this.group.lastMeasurement.densityComp) + ')'
    },
    status () {
      return this.Maglink.GetStatusInfo(this.group.lastMeasurement.tankStatus).statusDesc
    },
    levelUnit () {
      return this.options.levelUnits[this.systemSettings.levelUnit || 0].desc
    },
    volumeUnit () {
      return this.options.volumeUnits[this.systemSettings.volumeUnit || 0].desc
    },
    currentDate () {
      return this.Maglink.GetCustomDateTime(this.group.lastMeasurement.measuredOn, this.systemSettings.dateFormat)
    },
    imageUrl () {
      let imagePath = './img/group/group-empty-{0}{1}.svg'
      let lastMeasure = this.group.lastMeasurement
      let maxVolume = lastMeasure.productVolume + lastMeasure.ullage
      let hasWater = (lastMeasure.waterVolume > 0) ? '-water' : ''
      // check empty group
      if (lastMeasure.productVolume === 0) {
        imagePath = imagePath.replace('{0}', this.group.connectedTanks.length)
        imagePath = imagePath.replace('{1}', hasWater)

        return imagePath
      }

      // get % value
      let percValue = lastMeasure.productVolume === 0 ? 0 : Math.round((lastMeasure.productVolume * 100) / maxVolume)
      percValue = (Math.round(percValue / 10) * 10) + 10
      if (percValue >= 100) {
        percValue = 100
      }
      percValue = ('00' + percValue).slice(-3)

      let prodFamily = this.group.productFamily
      imagePath = './img/group/group-{0}-{1}-{2}{3}.svg'
      imagePath = imagePath.replace('{0}', this.Maglink.TankColor[prodFamily]) // 0..12
      imagePath = imagePath.replace('{1}', percValue)
      imagePath = imagePath.replace('{2}', this.group.connectedTanks.length)
      imagePath = imagePath.replace('{3}', hasWater)

      return imagePath
    }
  },
  mounted () {
    this.tankList = this.group.connectedTanks.join(', ')
    this.tankGroupInfo = this.$t('Tank group "{0}" (tanks: "{1}")', [ this.group.groupDescription, this.tankList ])
  },
  methods: {
    getText () {
      let maxVolume = this.group.lastMeasurement.productVolume + this.group.lastMeasurement.ullage
      let result = this.$t('Consolidated max volume {0}', [this.Maglink.VolumeToDisplay(maxVolume, this.systemSettings.volumeUnit)])
      result += ' ' + this.$t(this.volumeUnits)

      return result
    },
    getTitle () {
      return this.tankGroupInfo
    },
    getVolume () {
      let result = this.Maglink.VolumeToDisplay(this.group.lastMeasurement.productVolume, this.systemSettings.volumeUnit)
      result += ' (' + this.Maglink.VolumeToDisplay(this.group.lastMeasurement.productVolumeComp, this.systemSettings.volumeUnit) + ')'

      return result
    },
    snack (color, message) {
      message = this.$t('Tank group status') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
